<template>
    <div :id="id" class="vfb-help" :class="className">
        {{ helpText }}
    </div>
</template>

<script lang="ts" setup>
interface Props {
    helpText: string,
    className?: string,
    id: string,
}

defineProps<Props>();
</script>
